<template>
  <OutlineContainer>
    <div class="d-flex align-items-center mb-3">
      <AvatarBox
        :avatar="user.avatar"
        class="mr-3"
      />
      <AuthorNameText>{{ user.name }}</AuthorNameText>
    </div>
    <AuthorAboutText>{{ user.teacher_description }}</AuthorAboutText>
  </OutlineContainer>
</template>

<script>
  import AvatarBox from './AvatarBox'
  import AuthorNameText from '@/components/text/user/AuthorNameText'
  import AuthorAboutText from '@/components/text/user/AuthorAboutText'
  import OutlineContainer from '@/components/layout/containers/OutlineContainer'

  export default {
    components: {
      AvatarBox,
      AuthorAboutText,
      AuthorNameText,
      OutlineContainer,
    },
    props: {
      user: { type: Object, default: () => ({}) }
    }
  }
</script>